/*
  Women's Wellness Bundle landing page – behaviour
  1. smooth-scroll CTAs to the buy box   2. gallery thumbnails   3. format / purchase option + add to cart

  CONFIG: paste your Shopify variant IDs (and the subscription selling-plan IDs) below.
  Until a variant ID is set, "Add to cart" sends the shopper to FALLBACK_URL.
*/
(function () {
  'use strict';

  var DEFAULTS = {
    currency: 'USD',
    fallbackUrl: '/collections/all',
    subscribeDiscount: 15,
    formats: {
      gummies:  { price: 29.22, wasPrice: 44.95, subPrice: 24.84, subWasPrice: 38.21, comparePrice: 49.90, variantId: '', sellingPlanId: '' },
      capsules: { price: 29.22, wasPrice: 44.95, subPrice: 24.84, subWasPrice: 38.21, comparePrice: 49.90, variantId: '', sellingPlanId: '' }
    }
  };

  var userConfig = window.EWB_CONFIG || {};
  var CONFIG = Object.assign({}, DEFAULTS, userConfig);
  if (userConfig.formats) {
    CONFIG.formats = {
      gummies: Object.assign({}, DEFAULTS.formats.gummies, userConfig.formats.gummies || {}),
      capsules: Object.assign({}, DEFAULTS.formats.capsules, userConfig.formats.capsules || {})
    };
  }

  var root = document.querySelector('.ewb');
  if (!root) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. anchor CTAs ---- */
  root.querySelectorAll('[data-ewb-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
    });
  });

  /* ---- 2. gallery ---- */
  var gallery = root.querySelector('[data-ewb-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-ewb-main]');
    var thumbs = gallery.querySelectorAll('.ewb-thumb');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === btn ? 'true' : 'false'); });
      });
    });
  }

  /* ---- 3. buy box ---- */
  var form = root.querySelector('[data-ewb-form]');
  if (!form) return;

  var atc = form.querySelector('[data-ewb-atc]');
  var status = form.querySelector('[data-ewb-status]');
  var nowEl = root.querySelector('.ewb-price__now');
  var wasEl = root.querySelector('.ewb-price__was');
  var subNowEl = form.querySelector('[data-ewb-sub-now]');
  var subWasEl = form.querySelector('[data-ewb-sub-was]');
  var oneNowEl = form.querySelector('[data-ewb-one-now]');
  var oneWasEl = form.querySelector('[data-ewb-one-was]');
  var planTitles = form.querySelectorAll('.ewb-opt--plan .ewb-opt__title');
  var subPriceEl = planTitles[0] ? planTitles[0].lastElementChild : null;
  var onePriceEl = planTitles[1] ? planTitles[1].lastElementChild : null;

  var money = (function () {
    try {
      var f = new Intl.NumberFormat('en-US', { style: 'currency', currency: CONFIG.currency });
      return function (n) { return f.format(n); };
    } catch (e) {
      return function (n) { return '$' + Number(n).toFixed(2); };
    }
  })();

  function selected(name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  }

  function openCartDrawer() {
    var drawer = document.querySelector('en-drawer[data-id="cart-drawer"]');
    if (drawer) {
      drawer.setAttribute('expanded', '');
      drawer.classList.add('visible');
      document.body.classList.add('overflow-hidden');
      var handleClose = function (e) {
        if (
          e.target.classList.contains('overlay-full') ||
          e.target.classList.contains('drawer-close') ||
          e.target.classList.contains('close-drawer')
        ) {
          drawer.removeAttribute('expanded');
          drawer.classList.remove('visible');
          document.body.classList.remove('overflow-hidden');
          drawer.removeEventListener('click', handleClose);
        }
      };
      drawer.addEventListener('click', handleClose);
    }
  }

  function render() {
    var fmt = CONFIG.formats[selected('ewb-format')] || CONFIG.formats.gummies;
    var subscribe = selected('ewb-purchase') === 'subscribe';

    var onePrice = typeof fmt.price === 'number' ? fmt.price : 29.22;
    var oneWas = typeof fmt.wasPrice === 'number' ? fmt.wasPrice : 44.95;
    var subPrice = typeof fmt.subPrice === 'number' ? fmt.subPrice : (Math.round(onePrice * (100 - CONFIG.subscribeDiscount)) / 100);
    var subWas = typeof fmt.subWasPrice === 'number' ? fmt.subWasPrice : 38.21;

    var currentNow = subscribe ? subPrice : onePrice;
    var currentWas = subscribe ? subWas : oneWas;

    if (nowEl) nowEl.textContent = money(currentNow);
    if (wasEl) wasEl.textContent = money(currentWas);

    if (subNowEl) {
      subNowEl.textContent = money(subPrice);
    } else if (subPriceEl) {
      subPriceEl.textContent = money(subPrice);
    }

    if (subWasEl) subWasEl.textContent = money(subWas);

    if (oneNowEl) {
      oneNowEl.textContent = money(onePrice);
    } else if (onePriceEl) {
      onePriceEl.textContent = money(onePrice);
    }

    if (oneWasEl) oneWasEl.textContent = money(oneWas);

    if (atc) atc.textContent = 'Add to cart – ' + money(currentNow);

    var idInput = form.querySelector('input[name="id"]');
    if (idInput && fmt.variantId) {
      idInput.value = fmt.variantId;
    }
    var planInput = form.querySelector('input[name="selling_plan"]');
    if (planInput) {
      if (subscribe && fmt.sellingPlanId) {
        planInput.value = fmt.sellingPlanId;
        planInput.removeAttribute('disabled');
      } else {
        planInput.value = '';
        planInput.setAttribute('disabled', 'disabled');
      }
    }
  }

  form.addEventListener('change', render);

  // Listen for liquidAjaxCart requests to open cart drawer if Recharge doesn't handle it
  document.addEventListener('liquid-ajax-cart:request-end', function (event) {
    var requestState = event.detail && event.detail.requestState;
    if (requestState && requestState.requestType === 'add' && requestState.responseData && requestState.responseData.ok) {
      atc.disabled = false;
      openCartDrawer();
    }
  });

  // Handle submit while keeping compatibility with ajax-cart-product-form and Recharge
  form.addEventListener('submit', function (e) {
    var fmt = CONFIG.formats[selected('ewb-format')] || CONFIG.formats.gummies;
    var subscribe = selected('ewb-purchase') === 'subscribe';
    status.textContent = '';

    if (!fmt.variantId) {
      e.preventDefault();
      window.location.href = CONFIG.fallbackUrl;
      return;
    }

    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = fmt.variantId;

    var planInput = form.querySelector('input[name="selling_plan"]');
    if (planInput) {
      if (subscribe && fmt.sellingPlanId) {
        planInput.value = fmt.sellingPlanId;
        planInput.removeAttribute('disabled');
      } else {
        planInput.value = '';
        planInput.setAttribute('disabled', 'disabled');
      }
    }

    // Fallback if not inside an ajax-cart-product-form element
    if (!form.closest('ajax-cart-product-form')) {
      e.preventDefault();
      var item = { id: Number(fmt.variantId), quantity: 1 };
      if (subscribe && fmt.sellingPlanId) item.selling_plan = Number(fmt.sellingPlanId);

      atc.disabled = true;
      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
        window.liquidAjaxCart.add(
          { items: [item] },
          {
            lastCallback: function (requestState) {
              atc.disabled = false;
              if (requestState.responseData && requestState.responseData.ok) {
                openCartDrawer();
              } else {
                status.textContent = 'Sorry, we couldn’t add that to your cart. Please try again.';
              }
            }
          }
        );
      } else {
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            atc.disabled = false;
            openCartDrawer();
          })
          .catch(function () {
            atc.disabled = false;
            status.textContent = 'Sorry, we couldn’t add that to your cart. Please try again.';
          });
      }
    }
  });

  render();
})();
